<template>
    <div class="c2">
        <div class="c2-content">
            <div class="list-head">
                <div class="text" style="width: 60px;"></div>
                <div class="text" :style="{ width: textnum + 'px' }"
                    v-for="(item, i) in valueMap" :key="i">
                    {{ item.name }}
                </div>
            </div>
            <div class="text-area" ref="content" @mouseenter="mouseenterEvent()" @mouseleave="mouseleaveEvent()">
                <div class="list-content" ref="scroll1">
                    <div class="list-item" v-for="(item, i) in defaultdata" :key="i">
                        <div class="text" style="width: 60px;">
                            <img src="@/assets/temimg2/list-icon.png" alt="">
                        </div>
                        <div class="text" :style="{ width: textnum + 'px', color: i > 0 && i < 3 ? '#4EA3E6' : '' }"
                            v-for="(del, i) in valueMap" :key="i">
                            <span>{{ item[del.key] }}</span>
                        </div>
                    </div>
                </div>
                <div class="list-content" ref="scroll2" v-if="defaultdata.length > 12">
                    <div class="list-item" v-for="(item, i) in defaultdata" :key="i">
                        <div class="text" style="width: 60px;">
                            <img src="@/assets/temimg2/list-icon.png" alt="">
                        </div>
                        <div class="text" :style="{ width: textnum + 'px', color: i > 0 && i < 3 ? '#4EA3E6' : '' }"
                            v-for="(del, i) in valueMap" :key="i">
                            <span>{{ item[del.key] }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'template.scope10',
    props: {
        vdata: {
            type: Array,
            default: () => []
        },
		jsondata: {
			type: [Array, String],
			default: () => []
		},
        valuemap: {
            type: [Array, String],
            default: () => []
        }
    },
    data() {
        return {
            isList: true,
            textnum: 127,
            timer: null,
            defaultdata: [
                { value1: '数据一', value2: '数据一', value3: '数据一', value4: '数据一', value5: '数据一', value6: '数据一', value7: '数据一', value8: '数据一', value9: '数据一', value10: '数据一' },
                { value1: '数据二', value2: '数据二', value3: '数据二', value4: '数据二', value5: '数据二', value6: '数据二', value7: '数据二', value8: '数据二', value9: '数据二', value10: '数据二' },
                { value1: '数据三', value2: '数据三', value3: '数据三', value4: '数据三', value5: '数据三', value6: '数据三', value7: '数据三', value8: '数据三', value9: '数据三', value10: '数据三' },
                { value1: '数据四', value2: '数据四', value3: '数据四', value4: '数据四', value5: '数据四', value6: '数据四', value7: '数据四', value8: '数据四', value9: '数据四', value10: '数据四' },
                { value1: '数据五', value2: '数据五', value3: '数据五', value4: '数据五', value5: '数据五', value6: '数据五', value7: '数据五', value8: '数据五', value9: '数据五', value10: '数据五' },
                { value1: '数据六', value2: '数据六', value3: '数据六', value4: '数据六', value5: '数据六', value6: '数据六', value7: '数据六', value8: '数据六', value9: '数据六', value10: '数据六' },
                { value1: '数据七', value2: '数据七', value3: '数据七', value4: '数据七', value5: '数据七', value6: '数据七', value7: '数据七', value8: '数据七', value9: '数据七', value10: '数据七' },
                { value1: '数据八', value2: '数据八', value3: '数据八', value4: '数据八', value5: '数据八', value6: '数据八', value7: '数据八', value8: '数据八', value9: '数据八', value10: '数据八' },
                { value1: '数据九', value2: '数据九', value3: '数据九', value4: '数据九', value5: '数据九', value6: '数据九', value7: '数据九', value8: '数据九', value9: '数据九', value10: '数据九' },
                { value1: '数据十', value2: '数据十', value3: '数据十', value4: '数据十', value5: '数据十', value6: '数据十', value7: '数据十', value8: '数据十', value9: '数据十', value10: '数据十' },
                { value1: '数据十一', value2: '数据十一', value3: '数据十一', value4: '数据十一', value5: '数据十一', value6: '数据十一', value7: '数据十一', value8: '数据十一', value9: '数据十一', value10: '数据十一' },
                { value1: '数据十二', value2: '数据十二', value3: '数据十二', value4: '数据十二', value5: '数据十二', value6: '数据十二', value7: '数据十二', value8: '数据十二', value9: '数据十二', value10: '数据十二' },
                { value1: '数据十三', value2: '数据十三', value3: '数据十三', value4: '数据十三', value5: '数据十三', value6: '数据十三', value7: '数据十三', value8: '数据十三', value9: '数据十三', value10: '数据十三' },
                { value1: '数据十四', value2: '数据十四', value3: '数据十四', value4: '数据十四', value5: '数据十四', value6: '数据十四', value7: '数据十四', value8: '数据十四', value9: '数据十四', value10: '数据十四' },
            ],
            valueMap: [
                { name: '列一', key: "value1" },
                { name: '列二', key: "value2" },
                { name: '列三', key: "value3" },
                { name: '列四', key: 'value4' },
                { name: '列五', key: 'value5' },
                { name: '列六', key: 'value6' },
                { name: '列七', key: 'value7' },
                { name: '列八', key: 'value8' },
                { name: '列九', key: 'value9' },
                { name: '列十', key: 'value10' },
            ],
			exceldata: []
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                const box = this.$refs.content
                box.scrollTop = 0
                this.defaultdata = n
            }
        },
        valuemap(n) {
            if (n && n.length) {
                const box = this.$refs.content
                box.scrollTop = 0
                this.valueMap = n
                this.getWidth()
            }
        },
		jsondata(n) {
			this.exceldata = n
		}
    },
    mounted() {
        this.$nextTick(() => {
            this.rollUp(150)
        })
        if (this.valuemap && this.valuemap.length) {
            this.valueMap = this.valuemap
        }
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        this.getWidth()
    },

    methods: {
        rollUp(t) {
            const ulf1 = this.$refs.scroll1
            const box = this.$refs.content
            if (ulf1.offsetHeight > 120) {
                box.scrollTop = 0
                this.timer = setInterval(this.rollStart, t)
            } else if (ulf1.offsetHeight == 0) {
                setTimeout(() => {
                    this.rollUp(150)
                }, 200);
            }
        },
        rollStart() {
            const ulf1 = this.$refs.scroll1
            const box = this.$refs.content
            if (box.scrollTop >= ulf1.scrollHeight) {
                box.scrollTop = 0;
            } else {
                box.scrollTop += 2;
            }
        },
        mouseenterEvent() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        mouseleaveEvent(t) {
            if (!this.timer) {
                this.timer = setInterval(this.rollStart, 150);
            }
        },
        getWidth() {
            const headnum = this.valueMap.length
            if (headnum) {
                this.textnum = (914 - 83 ) / headnum
            } else {
                setTimeout(() => {
                    this.getWidth()
                }, 200);
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    }
}
</script>

<style scoped lang="scss">
.c2 {
    width: 100%;
    height: 530px;
    padding: 10px 0 20px 0;
    z-index: 1;
    position: relative;
    overflow: hidden;
    .c2-content {
        height: 100%;
    }
    .head {
        width: 100%;
        height: 46px;
        position: relative;
        display: flex;
        align-items: center;
    }

    .title-img {
        width: 100%;
        height: 46px;
        left: 0;
        top: 3px;
        position: absolute;
    }

    .layerName {
        margin-left: 42px;
        z-index: 1;
        font-family: 'pmzd';
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 15px;
        text-shadow: 0px 0px 10px rgba(41, 81, 202, 0.8), 0px 0px 10px rgba(41, 81, 202, 0.8), 0px 0px 10px rgba(41, 81, 202, 0.8);
    }

    .layerEng {
        margin-left: 12px;
        z-index: 1;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #8798AC;
        line-height: 15px;
    }

    .more {
        margin: 0 24px 0 auto;
        z-index: 1;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #51A0F4;
        line-height: 15px;
        cursor: pointer;
        pointer-events: auto;
    }

    .text {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        line-height: 15px;
        // width: 103px;
        // max-width: 103px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;

        img {
            width: 23px;
            height: 19px;
        }
    }

    .list-head {
        display: flex;
        align-items: center;
        margin: 16px 0;

        .text {
            color: #51A0F4;
        }
    }

    .list-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        background: rgba(59, 120, 177, .05);

        .text {
            color: #C6D2D8;
        }

        &:nth-child(2n + 1) {
            background: rgba(59, 120, 177, .16);
        }
    }

    .list-icon {
        width: 32px;
        height: 13px;
        position: relative;

        img {
            width: 17px;
            height: 13px;
            position: absolute;
            right: 0;
        }
    }

    .text-area {
        pointer-events: auto;
        max-height: 470px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 0;
        }
    }
}
</style>